export const RewardsAbi = [
  {
    inputs: [
      {
        internalType: 'contract Storage',
        name: 'storageAddress',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  { inputs: [], name: 'ContractHasNotBeenInitialized', type: 'error' },
  { inputs: [], name: 'ContractNotFound', type: 'error' },
  { inputs: [], name: 'ContractPaused', type: 'error' },
  { inputs: [], name: 'IncorrectRewardsDistribution', type: 'error' },
  { inputs: [], name: 'InvalidOrOutdatedContract', type: 'error' },
  { inputs: [], name: 'MaximumTokensReached', type: 'error' },
  { inputs: [], name: 'MustBeGuardian', type: 'error' },
  { inputs: [], name: 'MustBeGuardianOrValidContract', type: 'error' },
  { inputs: [], name: 'MustBeMultisig', type: 'error' },
  { inputs: [], name: 'UnableToStartRewardsCycle', type: 'error' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'ClaimNodeOpRewardsTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newTokens',
        type: 'uint256',
      },
    ],
    name: 'GGPInflated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'MultisigRewardsTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalRewardsAmt',
        type: 'uint256',
      },
    ],
    name: 'NewRewardsCycleStarted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'ProtocolDAORewardsTransferred',
    type: 'event',
  },
  {
    inputs: [],
    name: 'canStartRewardsCycle',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'claimingContract', type: 'string' }],
    name: 'getClaimingContractDistribution',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInflationAmt',
    outputs: [
      { internalType: 'uint256', name: 'currentTotalSupply', type: 'uint256' },
      { internalType: 'uint256', name: 'newTotalSupply', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInflationIntervalStartTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInflationIntervalsElapsed',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRewardsCycleCount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRewardsCycleStartTime',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRewardsCycleTotalAmt',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRewardsCyclesElapsed',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'startRewardsCycle',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'version',
    outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
